import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdcc1f14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "approve-backdrop"
}
const _hoisted_2 = {
  key: 0,
  class: "approve-modal-container"
}
const _hoisted_3 = {
  key: 0,
  class: "approve-modal approve-modal-prompt"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "approve-title" }, "Approve Claim", -1))
const _hoisted_5 = { class: "approve-receipt" }
const _hoisted_6 = { class: "approve-receipt-review" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "approve-receipt-detail" }
const _hoisted_9 = { class: "approve-receipt-title" }
const _hoisted_10 = { class: "approve-receipt-creator" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "approve-br" }, null, -1))
const _hoisted_12 = { class: "approve-receipt-line" }
const _hoisted_13 = { class: "approve-receipt-line-item label" }
const _hoisted_14 = { class: "approve-receipt-line-item value" }
const _hoisted_15 = { class: "approve-receipt-line" }
const _hoisted_16 = { class: "approve-receipt-line-item secondary" }
const _hoisted_17 = { class: "approve-receipt-line-item secondary" }
const _hoisted_18 = {
  key: 0,
  class: "approve-br"
}
const _hoisted_19 = {
  key: 1,
  class: "approve-receipt-line"
}
const _hoisted_20 = { class: "approve-receipt-line-item label" }
const _hoisted_21 = { class: "approve-receipt-line-item value" }
const _hoisted_22 = {
  key: 2,
  class: "approve-receipt-line"
}
const _hoisted_23 = { class: "approve-receipt-line-item secondary" }
const _hoisted_24 = { class: "approve-receipt-line-item secondary" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "approve-br white" }, null, -1))
const _hoisted_26 = { class: "approve-receipt-line" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "approve-receipt-line-item label bold" }, "Total", -1))
const _hoisted_28 = { class: "approve-receipt-line-item value bold" }
const _hoisted_29 = { class: "approve-receipt-line" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_31 = { class: "approve-receipt-line-item secondary" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "approve-br" }, null, -1))
const _hoisted_34 = { class: "approve-cta" }
const _hoisted_35 = { class: "approve-cta-title" }
const _hoisted_36 = { class: "approve-cta-subtitle" }
const _hoisted_37 = { class: "approve-cta-indicator" }

import { BigNumber } from '@ethersproject/bignumber';
import { formatEther } from '@ethersproject/units';
import { parseEther } from 'ethers/lib/utils';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { EXTENSION_TRAITS } from '@/common/constants';
import resolveEns from '../lib/resolveEns';
import PulsingIndicator from './PulsingIndicator.vue';

const ZERO_COST = '$0.00';

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmMintDialog',
  props: {
  isOpen: Boolean,
  mintCount: Number,
  isConfirming: Boolean,
  claimConfig: Object,
  claim: Object
},
  setup(__props) {

const props = __props;

const DEV_FEE = parseEther('0.00069');
// eslint-disable-next-line


// Creator Address Logic

const ensOrAddress = ref<string | undefined>(undefined);

const claimCost = computed(() => {
  if (!props.claim?.cost) return BigNumber.from(0);
  return BigNumber.from(props.claim.cost);
});

// copied from https://github.com/manifoldxyz/creator-identity-widget/blob/main/src/exports/MWalletIdentity.vue
const formatAddress = (address: string) : string => {
  address = address.toLowerCase();
  if (address.indexOf('0x') >= 0) {
    return `${address.slice(0, 5)}...${address.slice(-3)}`;
  } else {
    return `0x${address.slice(0, 3)}...${address.slice(-3)}`;
  }
};
resolveEns(props.claimConfig?.creator.address).then((ensResult) => {
  if (ensResult?.resolved) {
    ensOrAddress.value = ensResult.resolved;
  } else if (props.claimConfig?.creator.address) {
    ensOrAddress.value = formatAddress(props.claimConfig?.creator.address);
  }
});

// Multiplier and Price Logic

const useFees = computed(() => {
  return true;
});
const useMultipliers = computed(() => {
  return props.mintCount && props.mintCount > 1;
});

const multiplierText = computed(() => {
  if (!props.mintCount) return '';
  if (isNaN(props.mintCount)) return '';
  if (props.mintCount === 1) return '';
  return ` × ${props.mintCount}`;
});

const priceString = computed(() => {
  if (!claimCost.value) return ZERO_COST;
  return formatEther(claimCost.value);
});
const priceSubtotal = computed((): BigNumber => {
  if (!props.mintCount || isNaN(props.mintCount) || !claimCost.value) return BigNumber.from(0);
  return claimCost.value.mul(props.mintCount);
});
const priceSubtotalString = computed((): string => {
  if (!props.mintCount) return '';
  if (isNaN(props.mintCount)) return '';
  if (!claimCost.value) return ZERO_COST;
  return formatEther(priceSubtotal.value);
});
const feeString = computed((): string => {
  const feeToUse = DEV_FEE;
  return formatEther(feeToUse);
});
const feeSubtotal = computed((): BigNumber => {
  if (!props.mintCount || isNaN(props.mintCount)) return BigNumber.from(0);
  const feeToUse = DEV_FEE;
  return feeToUse.mul(props.mintCount);
});
const feeSubtotalString = computed((): string => {
  if (!props.mintCount) return '';
  if (isNaN(props.mintCount)) return '';
  return formatEther(feeSubtotal.value);
});
const total = computed((): BigNumber => {
  if (!props.mintCount) return BigNumber.from(0);
  return priceSubtotal.value.add(feeSubtotal.value);
});
const totalString = computed((): string => {
  if (!props.mintCount) return '';
  const totalAmount = total.value;
  if (totalAmount.eq(0)) return ZERO_COST;
  return formatEther(totalAmount);
});

// Exchange Rate Logic

const exRate = ref(1);
const updateExRate = async () => {
  const x = await fetch('https://api.coinbase.com/v2/prices/ETH-USD/spot', {
    method: 'GET'
  });
  const ethToUsdJson = await x.json();
  exRate.value = parseFloat(ethToUsdJson.data.amount);
};

const exRateIntervalId = ref<number | undefined>();
onMounted(() => {
  updateExRate();
  // vscode has a problem with setInterval bc it wants to use a Node.js type
  exRateIntervalId.value = (setInterval(updateExRate, 30000) as any as number);
});
onUnmounted(() => {
  if (exRateIntervalId.value) {
    clearInterval(exRateIntervalId.value);
  }
});

// USD Price Logic
const usdPriceSubtotalString = computed((): string => {
  if (priceSubtotal.value.eq(0)) return ZERO_COST;
  if (!exRate.value) return ZERO_COST;
  return `~$${((+formatEther(priceSubtotal.value)) * exRate.value).toFixed(2)}`;
});
const usdFeeSubtotalString = computed((): string => {
  if (feeSubtotal.value.eq(0)) return ZERO_COST;
  if (!exRate.value) return ZERO_COST;
  return `~$${((+formatEther(feeSubtotal.value)) * exRate.value).toFixed(2)}`;
});
const usdTotalString = computed((): string => {
  if (total.value.eq(0)) return ZERO_COST;
  if (!exRate.value) return ZERO_COST;
  return `~$${((+formatEther(total.value)) * exRate.value).toFixed(2)}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "backdrop" }, {
      default: _withCtx(() => [
        (props.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (props.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              true
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          class: "approve-receipt-thumb",
                          src: __props.claimConfig?.image
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.claimConfig?.name), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(ensOrAddress.value || '...'), 1)
                        ])
                      ]),
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, "Price" + _toDisplayString(multiplierText.value), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(priceSubtotalString.value) + " ETH", 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(useMultipliers.value ? `(${priceString.value}${multiplierText.value})` : ''), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(usdPriceSubtotalString.value) + " USD", 1)
                      ]),
                      (useFees.value)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_18))
                        : _createCommentVNode("", true),
                      (useFees.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, "Mint Fee" + _toDisplayString(multiplierText.value), 1),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(feeSubtotalString.value) + " ETH", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (useFees.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(useMultipliers.value ? `(${feeString.value}${multiplierText.value})` : ''), 1),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(usdFeeSubtotalString.value) + " USD", 1)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, _toDisplayString(useFees.value ? totalString.value : priceSubtotalString.value) + " ETH", 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, _toDisplayString(useFees.value ? usdTotalString.value : usdPriceSubtotalString.value) + " USD", 1)
                      ])
                    ]),
                    _hoisted_32,
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(props.isConfirming ?
              'Wallet Transaction Pending' :
              'Wallet Transaction Required'), 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(PulsingIndicator)
                        ]),
                        _createTextVNode(" " + _toDisplayString(props.isConfirming ?
                'Awaiting confirmation on the blockchain' :
                'Approve mint transaction from your wallet to check out'), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})